/**
 * 平台菜单 - 辅助管理
 */

export default [
  {
    label: 'menu.inventory001', //库存管理
    icon: 'icon-tongjichaxun',
    path: '/inventory',
    permission: 'taxcloud8124',
    id:'8124',
    children: [
      {
        label: 'menu.inventory002', //库存列表
        icon: 'm-kucunliebiao',
        path: '/inventory/inventoryAction_toStorageDetail.action',
        permission: 'taxcloud8125',
        id:'8125'
      },
      {
        label: 'menu.inventory004', //出入库申请
        icon: 'm-churukushenqing',
        path: '/inventory/inventoryAction_toBatchApplyIndex.action',
        permission: 'taxcloud8126',
        id:'8126'
      },
      {
        label: 'menu.inventory003', //出入库明细
        icon: 'm-churukumingxi',
        path: '/inventory/inventoryAction_toBatchDetailList.action',
        permission: 'taxcloud8127',
        id:'8127'
      },
      {
        label: 'menu.inventory005', //出入库报表
        icon: 'm-churukubaobiao',
        path: '/inventory/inventoryAction_toBatchDetailReport.action',
        permission: 'taxcloud8128',
        id:'8128'
      },
    ]
  }
];
